import ENV from "app/utils/ENV";
import apiActions from "app/utils/apiActions";
import storageActions from "app/utils/storageActions";
import valueActions from "app/utils/valueActions";
import textHelpers from "app/utils/textHelpers";
import alertActions from "app/utils/alertActions";
import * as RootNavigation from "app/utils/RootNavigation.js";
import { Platform, Alert, Vibration } from "react-native";

let draggableHelpers = {
  checkOverlap(coords = {}, ref = null, inspect = false) {
    // if(!ref) console.log(`no ref!!`)
    if (!ref) return;
    let m = !!ref?.pageY && !!ref?.pageX ? ref : ref?.state?.measurements;
    if (!m) return;
    let { x, y, width, height, pageX, pageY, absX, absY } = m;
    if (inspect) {
      console.log("inspecting", coords.y, pageY, pageY + height);
    }
    if (coords.x >= pageX && coords.x < pageX + width) {
      if (coords.y >= pageY && coords.y < pageY + height) {
        return true;
      }
    }
  },
  checkOrder(coords = {}, refObjs = [], draggingId) {
    if (!refObjs?.length) return;
    let orderedIdObjs = [
      {
        id: draggingId,
        x: coords.x,
      },
    ];
    for (let parentRef of refObjs) {
      let { ref, id } = parentRef;
      let x = ref?.state?.measurements?.pageX || 0;
      orderedIdObjs.push({ id, x });
    }
    // console.log([...orderedIdObjs])
    orderedIdObjs = textHelpers.oldestFirst(orderedIdObjs, "x");
    // console.log([...orderedIdObjs])
    let orderedIds = orderedIdObjs.map((x) => x.id);
    return orderedIds;
  },
  determineTextIcon(draggingVal, overlappedVal) {
    let relationship = draggableHelpers.determineRelationship(
      draggingVal,
      overlappedVal
    );
    if (relationship == "child") {
      return "cancel";
    } else if (relationship == "parent") {
      return null;
    } else if (relationship === false) {
      return "add";
    } else {
      return null;
    }
  },
  determineRelationship(value, other) {
    // if(value?.id == other?.id){
    //   if(value.parent_ids?.includes(value?.id) || value.child_ids?.includes(value?.id)){
    //     return true
    //   }
    //   else {
    //     return false
    //   }
    // }

    if (!value || !other) return null;

    if (value.parent_ids?.includes(other?.id)) {
      return "child";
    } else if (value.child_ids?.includes(other?.id)) {
      return "parent";
    } else {
      return false;
    }
  },
  async handleRelease(draggingVal, overlappedVal) {
    return new Promise(async (resolve, reject) => {
      let relationship = draggableHelpers.determineRelationship(
        draggingVal,
        overlappedVal
      );

      if (relationship == "child") {
        let warning =
          draggingVal.parent_ids?.length == 1
            ? `Warning: "${draggingVal.text}" will be orphaned.`
            : "";
        let res = await valueActions.confirm(
          "remove",
          "more",
          `Remove relationship?`,
          warning
        );
        console.log(res);
        if (res == 1) {
          let value = await valueActions.removeParent(
            draggingVal,
            overlappedVal
          );
          if (value) resolve(value);
          else reject();
        } else if (res == 2) {
          console.log("other actions......");
          let moreRes = await valueActions.confirm(
            "create intermediary",
            null,
            `Other actions:`
          );
          if (moreRes == 1) {
            RootNavigation.push("Create", {
              parent_ids: [overlappedVal.id],
              child_ids: [draggingVal.id],
              intermediary: true,
            });
          }
          resolve();
        } else {
          resolve();
        }
      }
      // not allowing parents to remove themselves from their children
      // else if (relationship == 'parent'){
      //   let warning = overlappedVal.parent_ids?.length == 1 ? `Warning: "${overlappedVal.text}" will be orphaned.` : ''
      //   let res = await valueActions.confirm('remove', null, `Remove relationship?`, warning)
      //   if(res == 1){
      //     let value = await valueActions.removeParent(overlappedVal, draggingVal)
      //     resolve()
      //   }
      //   else if(res == 2){
      //     resolve()
      //   }
      //   else {
      //     resolve()
      //   }
      // }
      else {
        let res = await valueActions.confirm(
          "adopt",
          null,
          `Make child of "${overlappedVal.text}"?`,
          ``
        );
        if (res == 1) {
          let value = await valueActions.addParent(draggingVal, overlappedVal);
          if (value) resolve(value);
          else reject();
        } else if (res == 2) {
          resolve();
        } else {
          resolve();
        }
      }
    });
  },
};

export default draggableHelpers;
